import Page from '../model/Page';

export default (page: Page): string => {
  const rangeTop = page.size * page.number;
  const rangeBottom = rangeTop - page.size + 1;
  const range = `${rangeBottom} - ${rangeTop > page.totalElements ? page.totalElements : rangeTop}`;

  return `Zmeny termínu ${range} z ${page.totalElements}`;
};
